export default __webpack_public_path__ + "static/media/2478.90294c60.png";